import React from 'react';
import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

import { Stage, Layer, Rect, Text, Line } from 'react-konva';
import {
  blueGrey,
  blue,
  grey,
} from '@material-ui/core/colors'

class SubmissionDetailMindMap extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},

      stageWidth: 375,
      stageHeight: 300,
      boxWidth: 100,
      boxHeight: 40,
      boxPadding: 4,
      linkList: [],
      boxList: [],
      userAnswer: [],
    };
    autoBind(this);
    if (this.props.parent.state.answerData != null && this.props.parent.state.answerData.answer != "") {
      // add try catch to the answer parser
      try{
        this.state.userAnswer = JSON.parse(this.props.parent.state.answerData.answer);
      }
      catch(err){
        console.log("this answer data is problematic");
      }
    }
    // let payload = JSON.parse(this.props.componentData.payload);
    let payload = '';
    try{
      payload = JSON.parse(this.props.componentData.payload.replace(/[\n\r]/g, ''));
      console.log("payload:", payload);
    }
    catch(err){
      console.log('the following payload causes the error:');
      for (let i = 0; i < this.state.componentData.payload.length; i++) {
        console.log(i.toString()+': '+this.state.componentData.payload[i].charCodeAt(0) + ' ,' + this.state.componentData.payload[i]);
      }
      console.log(err);
    }
    if (payload != null) {
      this.state.linkList = (payload.linkList != null? payload.linkList : []);
      this.state.boxList = (payload.boxList != null? payload.boxList : []);
    }

    this.updateMindMapBoxDict();
  }

  updateMindMapBoxDict() {
    this.state.boxDict = {};
    for (let i = 0; i < this.state.boxList.length; i++) {
      let key = this.state.boxList[i].id;
      if (this.state.boxDict[key] == null) {
        this.state.boxDict[key] = this.state.boxList[i];
      }
    }
  }

  mindMapLink(link) {
    let points = [];
    let point0 = this.state.boxDict[link[0]];
    let point1 = this.state.boxDict[link[1]];
    if (point0 != null) {
      points.push(point0.x + this.state.boxWidth / 2);
      points.push(point0.y + this.state.boxHeight / 2);
    }
    if (point1 != null) {
      points.push(point1.x + this.state.boxWidth / 2);
      points.push(point1.y + this.state.boxHeight / 2);
    }
    let id = points.toString();
    return (
      <Line
        id={id}
        points={points}
        stroke={blueGrey[500]}
        strokeWidth={2}
      />
    )
  }

  mindMapBox(box, index) {
    let boxLabel = "";
    if (index < this.state.userAnswer.length) {
      boxLabel = this.state.userAnswer[index];
    }

    let kind = (box.kind != null? box.kind : 0);
    let x = (box.x != null? box.x : 0);
    let y = (box.y != null? box.y : 0);
    let color = blue[500];
    return [
      <Rect
        id={box.id}
        x={x}
        y={y}
        width={this.state.boxWidth}
        height={this.state.boxHeight}
        fill={color}
        cornerRadius={4}
        shadowBlur={4}
        shadowOffsetX={2}
        shadowOffsetY={2}
        shadowOpacity={0.4}
        draggable={false}
      />,
      <If condition={kind==0}>
        <Then>
          <Rect
            x={x + this.state.boxPadding / 2.0}
            y={y + this.state.boxPadding / 2.0}
            fill={'White'}
            width={this.state.boxWidth - this.state.boxPadding}
            height={this.state.boxHeight - this.state.boxPadding}
            cornerRadius={2}
          />
        </Then>
      </If>,
      <Text
        id={box.id}
        name='text'
        x={x + this.state.boxPadding / 2.0}
        y={y + this.state.boxPadding / 2.0}
        text={(kind == 0? box.label : boxLabel)}
        fill={kind == 0? 'Black' : 'White'}
        fontSize={12}
        align='center'
        verticalAlign='middle'
        wrap='word'
        width={this.state.boxWidth - this.state.boxPadding}
        height={this.state.boxHeight - this.state.boxPadding}
        draggable={false}
      />
    ]
  }

  render () {
    return (
      <Stage width={this.state.stageWidth} height={this.state.stageHeight}>
        <Layer>
          <Rect
            x={0}
            y={0}
            width={this.state.stageWidth}
            height={this.state.stageHeight}
            fill={grey[200]}
            cornerRadius={4}
          />
        </Layer>
        <Layer>
          {
            this.state.linkList.map( (link, i) => {
              return (
                this.mindMapLink(link)
              )
            })
          }
        </Layer>
        <Layer>
          {
            this.state.boxList.map( (box, i) => {
              return (
                this.mindMapBox(box, i)
              )
            })
          }
        </Layer>
      </Stage>
    )
  }
}

export default SubmissionDetailMindMap;
